export const UPLOAD_BASE_DELAY_MS = 30_000;
export const UPLOAD_MAX_DELAY_MS = 6 * 60 * 60 * 1000;

/** Backoff after `attempts` consecutive failures: 30 s doubling, cap 6 h, jitter +-20 %. Pure. */
export function nextUploadDelayMs(attempts: number, rand: () => number = Math.random): number {
  const n = Math.max(1, attempts);
  const base = Math.min(UPLOAD_BASE_DELAY_MS * 2 ** (n - 1), UPLOAD_MAX_DELAY_MS);
  return Math.round(base * (0.8 + 0.4 * rand()));
}
